import { useEffect } from "react";

const TabbyPromoSnippet = ({ price }) => {
  useEffect(() => {
    if (window.TabbyPromo) {
      new window.TabbyPromo({
        selector: "#TabbyPromo",
        currency: "AED",
        price: price,
        lang: "en",
        publicKey: "pk_019633ab-c819-cf12-1bef-02d967f475b6",
        merchantCode: "365LH",
      });
    }
  }, [price]);

  return <div id="TabbyPromo" className="mt-4 text-sm text-gray-600"></div>;
};

export default TabbyPromoSnippet;
